import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResourceHeader from '../../components/resource-header/resource-header.js';
import TotalHeader from './components/total-header/total-header.js';
import HeaderActions from './components/header-actions/header-actions.js';
import { Button } from '../../components/button/button.js';
import { EnlargeIcon, MinimizeIcon, EncircledPlusIcon } from '../../utils/svg-components.js';

const PlannerHeader = ({
  id,
  projectData,
  milestones,
  resources,
  materials,
  handleSave,
  discount,
  handleStatusChange,
  onPlannerTypeChange,
  discountObj,
  projectTotal,
  isFullScreenView,
  handleAddMilestone,
  isGeneralUser,
  project,
  contact,
  onToggleGantt,
  company,
}) => {
  const navigate = useNavigate();
  // Hide Gantt if plannerType is Materials
  const hideForMaterials = projectData.plannerType !== 'Materials';
  const showGanttButton =
    projectData.plannerType !== 'Materials' && projectData.plannerType !== 'Fixed Fee Project';
  return (
    <div className="info-container">
      <ResourceHeader
        title={projectData.projectName || projectData.acceloTitle}
        subTitle={`ID: ${id} | Client: ${company?.companyName}`}
        rightContent={
          <HeaderActions
            isTimelinesInValid={false}
            projectData={projectData}
            project={project}
            milestones={milestones}
            resources={resources}
            materials={materials}
            handleSave={handleSave}
            isGeneralUser={isGeneralUser}
            discount={discount}
            handleStatusChange={handleStatusChange}
            onPlannerTypeChange={onPlannerTypeChange}
            discountObj={discountObj}
            contact={contact}
          />
        }
        onBack={() => navigate(`/projectsview/${id}/details?isGroupView=false`)}
      />
      <TotalHeader
        title={'Project Total'}
        total={projectTotal}
        projectData={projectData}
        hideForMaterials={hideForMaterials}
        infoMessage={'Project total includes the service $ value only'}
        rightContent={
          <div className="flex">
            {/* {showGanttButton && (
              <Button
                startIcon={
                  isFullScreenView ? <MinimizeIcon /> : <EnlargeIcon />
                }
                variant="outlined"
                color={"secondary"}
                onClick={onToggleGantt}
              >
                View Gantt Chart
              </Button>
            )} */}
            {hideForMaterials && (
              <Button
                onClick={handleAddMilestone}
                startIcon={<EncircledPlusIcon />}
                size="large"
                variant="filled"
                color={'tertiary'}
              >
                Add Deliverable
              </Button>
            )}
          </div>
        }
      />
    </div>
  );
};

export default PlannerHeader;
